import { Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import { StyledImg } from '../../../../elements/atoms/styledImg/StyledImg';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';

interface ILifestyleQuestionnaireIntroProps {
    onClick: () => void;
}
export function LifestyleQuestionnaireIntro(props: Readonly<ILifestyleQuestionnaireIntroProps>) {
    return (
        <CustomContainer>
            <Stack>
                <Heading
                    as="h2"
                    size="xlarge"
                >
                    Een paar extra vragen
                </Heading>
            </Stack>

            <Stack>
                <StyledImg
                    alt="Een paar extra vragen introductie"
                    src="/assets/images/somnology/questionnaires/lifestyle-questionnaire-intro.svg"
                    srcSet="/assets/images/somnology/questionnaires/lifestyle-questionnaire-intro.svg 1x, /assets/images/somnology/questionnaires/lifestyle-questionnaire-intro.svg 2x, /assets/images/somnology/questionnaires/lifestyle-questionnaire-intro.svg 3x,"
                />
            </Stack>

            <Stack>
                <Text>
                    We willen je graag een paar vragen stellen over je gewicht, lengte en eventuele alcoholgebruik,
                    rookgedrag of drugsgebruik. Zo kan de slaaparts jouw situatie nog iets beter begrijpen.
                </Text>
            </Stack>

            <ButtonRow justify="right">
                <Button
                    color="secondary"
                    onClick={props.onClick}
                    variant="solid"
                    width="full-below-small"
                >
                    Start vragenlijst
                </Button>
            </ButtonRow>
        </CustomContainer>
    );
}
